import { useState } from "react";
import { Home, Target, Users, ArrowRight } from "lucide-react";

const PASSI = [
  { id: "panoramica", icon: Home, titolo: "Panoramica", testo: "Come LEUTELIA legge l'hotel oggi: identità, numeri veri, cosa è cambiato. Da qui parte tutto." },
  { id: "priorita", icon: Target, titolo: "Priorità e Soluzioni Pratiche", testo: "Le cose da fare questa settimana, in ordine, con problema → soluzione → quanto recuperi in euro." },
  { id: "reparti", icon: Users, titolo: "Direzione & Reparti", testo: "Come le segnalazioni arrivano al reparto giusto e come il direttore vede la mattina in due minuti." },
];

export default function Benvenuto({ user, hotelName, onNav, onClose }) {
  const key = `leu_demo_benvenuto_${user.email}`;
  const [open, setOpen] = useState(() => !localStorage.getItem(key));
  if (!open) return null;
  const chiudi = (nav) => { localStorage.setItem(key, "1"); setOpen(false); if (nav) onNav(nav); onClose?.(); };
  return (
    <div className="fixed inset-0 z-[85] bg-brand-greenDark/70 backdrop-blur-sm flex items-center justify-center p-4" data-testid="demo-benvenuto">
      <div className="w-full max-w-[720px] bg-brand-cream rounded-2xl border border-brand-gold/40 p-6 sm:p-9 leu-in shadow-2xl">
        <div className="text-brand-orange font-bold tracking-[0.22em] text-[11px] uppercase">LEUTELIA Experience</div>
        <h2 className="font-serif text-[26px] sm:text-[32px] text-brand-ink leading-tight mt-2">Benvenuto, {user.name?.split(" ")[0] || "Direttore"}.</h2>
        <p className="text-[14px] text-brand-muted mt-2">Stai per vedere l'{hotelName} esattamente come lo vede il suo direttore: dati reali di analisi, in sola lettura. Tre cose da guardare, nell'ordine.</p>
        <ol className="mt-6 space-y-3">
          {PASSI.map((p, i) => {
            const Icon = p.icon;
            return (
              <li key={p.id}>
                <button onClick={() => chiudi(p.id)} className="w-full text-left flex items-start gap-4 rounded-xl bg-white border border-brand-gold/25 hover:border-brand-gold px-4 py-3.5 transition-colors group" data-testid={`benvenuto-passo-${p.id}`}>
                  <span className="w-9 h-9 rounded-full bg-brand-green text-brand-gold font-bold text-[13px] flex items-center justify-center shrink-0">{i + 1}</span>
                  <span className="min-w-0 flex-1">
                    <span className="flex items-center gap-2 font-serif text-[18px] text-brand-ink leading-tight"><Icon size={16} className="text-brand-gold" /> {p.titolo}</span>
                    <span className="block text-[13px] text-brand-muted mt-1">{p.testo}</span>
                  </span>
                  <ArrowRight size={16} className="text-brand-gold/60 group-hover:text-brand-gold mt-2 shrink-0" />
                </button>
              </li>
            );
          })}
        </ol>
        <div className="mt-6 flex items-center justify-between gap-3">
          <p className="text-[11.5px] text-brand-muted">I pulsanti operativi nella demo sono disattivati: nessuna azione modifica dati reali.</p>
          <button onClick={() => chiudi(null)} className="shrink-0 h-10 px-5 rounded-lg bg-brand-green text-brand-cream text-[13.5px] font-semibold" data-testid="benvenuto-inizia">Inizia dalla Panoramica</button>
        </div>
      </div>
    </div>
  );
}
